export default __webpack_public_path__ + "static/media/switch_wikimedia_use1.7568e9eb.png";